// components/clients/ClientsTable.jsx

import ClientRow from "./ClientRow";

export default function ClientsTable({
  clients,
  loading,
  isAdmin = false,
  onView,
  onEdit,
  onDelete,
  onAdd,
  formatDate,
}) {
  const isEmpty = !loading && clients.length === 0;

  return (
    <div className={`card shadow-sm clientsCard${isEmpty ? " clientsTableEmpty" : ""}`}>
      {/* <div className="table-responsive"> */}
      <table className={`table table-hover align-middle m-0 clientsTable${isEmpty ? " clientsTableEmpty" : ""}`}>
        <thead className="clientsTableHead">
          <tr>
            <th className="ps-3">Client</th>
            <th>Type</th>
            <th>Status</th>
            <th>KYC Status</th>
            <th>KYC Flow</th>
            <th>Last KYC</th>
            <th className="text-end clientsActionsCol">
              <span
                style={{
                  display: "inline-block",
                  transform: "translateX(-5px)",
                }}
              >
                KYC Form
              </span>
            </th>
            <th className="text-end pe-3 clientsActionsCol">
              {" "}
              <span
                style={{
                  display: "inline-block",
                  transform: "translateX(-15px)",
                }}
              >
                Client Profile
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          {loading && (
            <tr>
              <td colSpan={8} className="p-4 text-muted">
                Loading…
              </td>
            </tr>
          )}

          {isEmpty && (
            <tr className="clientsEmptyStateRow">
              <td colSpan={8} className="clientsEmptyStateCell">
                <div className="clientsEmptyStateCard">
                  <div>
                    {isAdmin
                      ? "No clients have been added in the database."
                      : "No clients have been added yet. Create your first client profile to get started."}
                  </div>
                  {!isAdmin && (
                    <button
                      type="button"
                      className="btn btn-sm clientsEmptyStateAddBtn"
                      onClick={onAdd}
                    >
                      Add client
                    </button>
                  )}
                </div>
              </td>
            </tr>
          )}

          {!loading &&
            clients.map((c) => (
              <ClientRow
                key={c.id}
                client={{
                  id: c.id,
                  clientName: c.clientName ?? "—",
                  clientType: c.clientType ?? "—",
                  status: c.status ?? "—",
                  lastKycLabel: formatDate(c.lastKycDate),
                  kycCompleted: !!c.kycCompleted,
                  kycFlowStage: c.kycFlowStage || "not_sent",
                  kycLastSubmissionId: c.kycLastSubmissionId ?? null,
                  // kycInviteSentAt: c.kycInviteSentAt || null,
                  // kycLastSubmissionAt: c.kycLastSubmissionAt || null,
                  // kycLastSubmissionId: c.kycLastSubmissionId || null,
                }}
                // onView={onView}
                onView={() => onView(c)}
                onEdit={() => onEdit(c)}
                onDelete={() => onDelete(c)}
              />
            ))}
        </tbody>
      </table>
      {/* </div> */}
    </div>
  );
}
